import React, {useState} from "react"
import theme from "./../../../Theme/Theme"
import { Div, Text, Row, Col } from "atomize";
import styled from "styled-components";
import {PrimaryButton} from "./../../Atoms/Button"
import Card from "../../Atoms/Card";
import ItemsCarousel from 'react-items-carousel';
import { ReactComponent as RightIcon } from './../../../Assets/Icons/arrow_right.svg';
import { ReactComponent as LeftIcon } from './../../../Assets/Icons/arrow_left.svg';
import useWindowSize from './../../../utils/useWindowSize';
import ActivitiesGroup from './../ActivitiesGroup'
import ArrowButton from "./../../Atoms/ArrowButton"
import {addActivities, removeActivity} from "../../../redux/actions";
import connect from "react-redux/es/connect/connect";
import {bindActionCreators} from "redux";
import {ExpandElipse} from "./../../../utils/truncateElipse";



const Wrapper = styled(Div)`
  .carousel-wrapper > div {
    overflow-x: unset;
  }
`;

const CardTitle = styled(Text)`
  color: ${theme.colors.dark};	
  font-family: Inter;	
  font-size: 16px;	
  font-weight: 600;	
  line-height: 30px;
  margin-bottom: .5rem !important;
`;

const StyledCard = styled.div`
  margin: 2rem 0 !important;
  background-color: white;
`;

const Bundle = (props) => {
  const {bundle} = props;
  const [loading, setLoading] = useState(false);

  React.useEffect( () => {
    setLoading(false)
  },[props.collectorActivities]);

  return (
    <StyledCard>
      <Card
        padding={'2rem'}
        width={'400px'}
      >
        <CardTitle
          tag={'h4'}
        >{bundle.title}
        </CardTitle>
        <Text
          tag={'p'}
        >
          <ExpandElipse
            text={bundle.field_description}
            max={250}
          />
        </Text>
        <ActivitiesGroup
          activities={bundle.field_activities}
          overflow={true}
        />
        {
          props.collectorActivities.filter(o1 => bundle.field_activities.some(o2 => o1.id === o2.id)).length === bundle.field_activities.length ?
            <PrimaryButton
              icon={'Minus'}
              type={'button'}
              action={() => {
                setLoading(false);
                bundle.field_activities.forEach( a => {
                  props.removeActivity(a)
                })
              }}
              text={'Remove from collection'}
            />
            :
            <PrimaryButton
              icon={loading?  "Loading" : 'Plus'}
              type={'button'}
              action={() => {
                setLoading(true);
                props.addActivities(bundle.field_activities)
              }}
              text={'Add to my collection'}
            />
        }
      </Card>
    </StyledCard>
  )
};

function Bundles(props) {

  const [activeItemIndex, setActiveItemIndex] = useState(0);
  const chevronWidth = 0;

  const size = useWindowSize();
  let cardNum = 3;
  if (size.width > 920) {
    cardNum = 3
  } else if (size.width > 766) {
    cardNum = 2;
  } else if (size.width > 500) {
    cardNum = 1.5;
  } else {
    cardNum = 1;
  }

  return (
    <Wrapper
      m={{ y: '2rem'}}
      style={{ padding: `0 ${chevronWidth}px` }}
    >
      {
        props.view === 'list' ?
          <Row>
            {
              props.bundles.map((bundle, i) => {
                return (
                  <Col
                    key={bundle.title + i}
                    size={{ xs: '12', sm: '12', md: '6', lg: '6' }}
                  >
                    <Bundle
                      bundle={bundle}
                      addActivities={props.addActivities}
                      removeActivity={props.removeActivity}
                      collectorActivities={props.collectorActivities}
                    />
                  </Col>
                )
              })
            }
          </Row>
        :
          <ItemsCarousel
            requestToChangeActive={setActiveItemIndex}
            activeItemIndex={activeItemIndex}
            numberOfCards={cardNum}
            gutter={20}
            leftChevron={<ArrowButton aria-label={'scroll activity bundles left'}>{ <LeftIcon />}</ArrowButton>}
            rightChevron={<ArrowButton aria-label={'scroll activity bundles right'}>{<RightIcon/>}</ArrowButton>}
            outsideChevron
            chevronWidth={chevronWidth}
            classes={{ wrapper: 'carousel-wrapper' }}
            showSlither={true}
          >
            {
              props.bundles.map( (bundle, i)=> {
                return (
                  <Bundle
                    key={bundle.title + i}
                    bundle={bundle}
                    addActivities={props.addActivities}
                    removeActivity={props.removeActivity}
                    collectorActivities={props.collectorActivities}
                  />
                )
              })
            }
          </ItemsCarousel>

      }
    </Wrapper>
  )
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      addActivities: addActivities,
      removeActivity: removeActivity
    },
    dispatch
  );
};

const mapStateToProps = state => {
  if (state === undefined) return {};
  return {
    collectorActivities: state.collectorActivities.collectorActivities
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Bundles);
